/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetMetricsGated = (typeof GetMetricsGated)[keyof typeof GetMetricsGated];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMetricsGated = {
  gated: 'gated',
  ungated: 'ungated',
} as const;
